import React from 'react';
import DefaultHeader from './index.default';
import FrontendBoardHeader from './index.frontend';
import RecruitmentHeader from './index.recruitment';
import NavigationSelfServeHeader from './index.selfserve';
import { showSelfServeHeader } from './queries';
import VymoWebHeader from './vymoWeb';

function Header() {
  if (window.APP === 'vymoWeb') {
    return <VymoWebHeader />;
  }

  if (showSelfServeHeader()) {
    return <NavigationSelfServeHeader />;
  }

  if (window.APP === 'frontendBoard') {
    return <FrontendBoardHeader />;
  }

  if (window.APP === 'recruitment') {
    return <RecruitmentHeader />;
  }

  return <DefaultHeader />;
}

export default Header;
